import request from './request';
function createPayload(params) {
    return {
        'endpoint_url': params.validationURL,
        'purchase_token': params.purchaseToken,
        'merchant_id': params.merchantId
    };
}
export default function applePaySession(apiHost, params) {
    return request({
        method: 'GET',
        url: apiHost + "/web/apple_pay_session",
        params: createPayload(params),
        contentType: null
    });
}
